import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';
import { Link, useRouteError } from 'react-router-dom';

import faceScreamingImg from '@pkg/assets/images/face-screaming.png';
import { CTAWrapper, ErrorWrapper, StyledImg } from '@pkg/components/Error/styles';
import { Navigation } from '@pkg/components/Navigation';
import { DepHoverContainer, DepUnderline } from '@pkg/components/deprecated';
import { useMediaQuery } from '@pkg/providers';

import config from '@app/config';

import { Typography } from '../DesignSystem';

export const ErrorElement = () => {
    const error = useRouteError() as Error;
    const { t } = useTranslation(['common']);
    const [hovering, setHovering] = useState(false);

    const { tablet } = useMediaQuery();

    return (
        <Navigation hideBackground displayZIndexTop>
            <ErrorWrapper>
                <StyledImg src={faceScreamingImg} alt={t('emoji', { emoji: 'Face screaming' })} />
                <Typography type="display" size={tablet ? 80 : 50} align={'center'}>
                    Something went wrong
                </Typography>
                <br />
                {process.env.NODE_ENV === 'development' && (
                    <Typography type="paragraph" size={18}>
                        {error?.message}
                    </Typography>
                )}
                <CTAWrapper>
                    <a
                        onMouseEnter={() => setHovering(true)}
                        onMouseLeave={() => setHovering(false)}
                        href={config.supportLink}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <DepHoverContainer>
                            <Typography type="headline">Let us know</Typography>
                            <DepUnderline $hovering={hovering} />
                        </DepHoverContainer>
                    </a>
                    <Link to="/">
                        <img src="/assets/img/yat-hand-purple-outline.svg" className="not-found-logo" alt={t('logo')} />
                    </Link>
                </CTAWrapper>
            </ErrorWrapper>
        </Navigation>
    );
};
